import React from 'react'
import { addMonths } from 'date-fns'
import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/outline'
import { Icon } from '@chakra-ui/react'

export const getWarrantyStatus = (warrantyEndDate: string | null) => {
  // no warranty
  if (!warrantyEndDate) return null

  const today = new Date()
  const warrantyEnd = new Date(warrantyEndDate)

  //  warranty expired
  if (today > warrantyEnd) {
    return 'expired'
  }

  // warranty expiring soon
  const threeMonthsBeforeWarrantyEnd = addMonths(warrantyEnd, -3)
  if (today >= threeMonthsBeforeWarrantyEnd) {
    return 'expiring_soon'
  }

  // warranty active
  return 'active'
}

export const getWarrantyIcon = (warrantyEndDate: string | null) => {
  const warrantyStatus = getWarrantyStatus(warrantyEndDate)

  switch (warrantyStatus) {
    case 'expired':
      return <Icon as={XCircleIcon} color='red.500' boxSize={4} />
    case 'expiring_soon':
      return <Icon as={ExclamationTriangleIcon} color='orange.500' boxSize={4} />
    case 'active':
      return <Icon as={CheckCircleIcon} color='green.500' boxSize={4} />
    default:
      return null
  }
}
